module.exports = __webpack_public_path__ + "img/first-left.8dc06657.png";